module.exports = __webpack_public_path__ + "static/img/face_tips4.d60f0fc6.png";